import '../../css/base.css';
import gallery3 from '../../img/gallery3.jpg';
import gallery4 from '../../img/gallery4.jpg';
import gallery5 from '../../img/gallery5.jpg';
import gallery6 from '../../img/gallery6.jpg';
import gallery7 from '../../img/gallery7.jpg';
import cottage2_large from '../../img/cottage/cottage2_large.jpg';
import cottage2_medium from '../../img/cottage/cottage2_medium.jpg';
import cottage2_small from '../../img/cottage/cottage2_small.jpg';
import cottage3_large from '../../img/cottage/cottage3_large.jpg';
import cottage3_medium from '../../img/cottage/cottage3_medium.jpg';
import cottage3_small from '../../img/cottage/cottage3_small.jpg';
import bedroom1_large from '../../img/gallery/bedroom1_large.jpg';
import bedroom1_medium from '../../img/gallery/bedroom1_medium.jpg';
import bedroom1_small from '../../img/gallery/bedroom1_small.jpg';
import bedroom2_large from '../../img/gallery/bedroom2_large.jpg';
import bedroom2_medium from '../../img/gallery/bedroom2_medium.jpg';
import bedroom2_small from '../../img/gallery/bedroom2_small.jpg';
import bedroom3_large from '../../img/gallery/bedroom3_large.jpg';
import bedroom3_medium from '../../img/gallery/bedroom3_medium.jpg';
import bedroom3_small from '../../img/gallery/bedroom3_small.jpg';
import caolIsla_small from '../../img/scenes/caolIsla_small.jpg';
import caolIsla_medium from '../../img/scenes/caolIsla_medium.jpg';
import caolIsla_large from '../../img/scenes/caolIsla_large.jpg';
import corranRoad_small from '../../img/scenes/corranRoad_small.jpg';
import corranRoad_medium from '../../img/scenes/corranRoad_medium.jpg';
import corranRoad_large from '../../img/scenes/corranRoad_large.jpg';
import floatingClouds_small from '../../img/scenes/floatingClouds_small.jpg';
import floatingClouds_medium from '../../img/scenes/floatingClouds_medium.jpg';
import floatingClouds_large from '../../img/scenes/floatingClouds_large.jpg';
import rainAndSun_small from '../../img/scenes/rainAndSun_small.jpg';
import rainAndSun_medium from '../../img/scenes/rainAndSun_medium.jpg';
import rainAndSun_large from '../../img/scenes/rainAndSun_large.jpg';
import rockyBeach_small from '../../img/scenes/rockyBeach_small.jpg';
import rockyBeach_medium from '../../img/scenes/rockyBeach_medium.jpg';
import rockyBeach_large from '../../img/scenes/rockyBeach_large.jpg';
import rockJumping_small from '../../img/scenes/rockJumping_small.jpg';
import rockJumping_medium from '../../img/scenes/rockJumping_medium.jpg';
import rockJumping_large from '../../img/scenes/rockJumping_large.jpg';
import kayakCalmDay_small from '../../img/scenes/kayakCalmDay_small.jpg';
import kayakCalmDay_medium from '../../img/scenes/kayakCalmDay_medium.jpg';
import kayakCalmDay_large from '../../img/scenes/kayakCalmDay_large.jpg';
import gallery11 from '../../img/gallery11.jpg';
import gallery12 from '../../img/gallery12.jpg';
import glenelgView_small from '../../img/glenelgView_small.jpg';
import glenelgView_medium from '../../img/glenelgView_medium.jpg';
import glenelgView_large from '../../img/glenelgView_large.jpg';
import overlookingSkye_small from '../../img/overlookingSkye_small.jpg';
import overlookingSkye_medium from '../../img/overlookingSkye_medium.jpg';
import overlookingSkye_large from '../../img/overlookingSkye_large.jpg';

const Gallery = () => {

  return (
    <div>
    <div className="row">
      <div className="col-12 col-md-6 imagesBackgroundColour no-padding">
        <picture>
          <source srcSet={`${cottage3_small} 1x,${cottage3_medium} 2x`} media="(max-width: 600px)" />
          <img srcSet={`${cottage3_medium} 1x,${cottage3_large} 2x`}
            src={cottage3_medium} alt="Cottage View 1" className="gallery-image"
          />
        </picture>
      </div>
      <div className="col-12 col-md-6 imagesBackgroundColour no-padding">
        <picture>
          <source srcSet={`${overlookingSkye_small} 1x,${overlookingSkye_medium} 2x`} media="(max-width: 600px)" />
          <img srcSet={`${overlookingSkye_medium} 1x,${overlookingSkye_large} 2x`}
            src={overlookingSkye_medium} alt="Skye viewpoint" className="gallery-image"
          />
        </picture>
      </div>
    </div>
    <div className="row">
      <div className="col-12 col-md-6 imagesBackgroundColour no-padding">
        <img src={gallery3} alt="Shore Cottage Gallery 3" className="gallery-image" />
      </div>
      <div className="col-12 col-md-6 imagesBackgroundColour no-padding">
        <img src={gallery4} alt="Shore Cottage Gallery 4" className="gallery-image" />
      </div>
    </div>
    <div className="row">
      <div className="col-12 col-md-6 imagesBackgroundColour no-padding">
        <img src={gallery5} alt="Shore Cottage Gallery 5" className="gallery-image" />
      </div>
      <div className="col-12 col-md-6 imagesBackgroundColour no-padding">
        <img src={gallery6} alt="Shore Cottage Gallery 6" className="gallery-image" />
      </div>
    </div>
    <div className="row">
    <div className="col-12 col-md-6 imagesBackgroundColour no-padding">
        <img src={gallery7} alt="Shore Cottage Gallery 7" className="gallery-image" />
      </div>
      <div className="col-12 col-md-6 imagesBackgroundColour no-padding">
        <picture>
          <source srcSet={`${bedroom1_small} 1x,${bedroom1_medium} 2x`} media="(max-width: 600px)" />
          <img srcSet={`${bedroom1_medium} 1x,${bedroom1_large} 2x`}
            src={bedroom1_medium} alt="Bedroom 1" className="gallery-image"
          />
        </picture>
      </div>
    </div>
    <div className="row">
      <div className="col-12 col-md-6 imagesBackgroundColour no-padding">
          <picture>
            <source srcSet={`${bedroom2_small} 1x,${bedroom2_medium} 2x`} media="(max-width: 600px)" />
            <img srcSet={`${bedroom2_medium} 1x,${bedroom2_large} 2x`}
              src={bedroom2_medium} alt="Bedroom 2" className="gallery-image"
            />
          </picture>
      </div>
      <div className="col-12 col-md-6 imagesBackgroundColour no-padding">
        <picture>
          <source srcSet={`${bedroom3_small} 1x,${bedroom3_medium} 2x`} media="(max-width: 600px)" />
          <img srcSet={`${bedroom3_medium} 1x,${bedroom3_large} 2x`}
            src={bedroom3_medium} alt="Bedroom 3" className="gallery-image"
          />
        </picture>
      </div>
    </div>
    <div className="row">
      <div className="col-12 col-md-6 imagesBackgroundColour no-padding">
        <img src={gallery11} alt="Shore Cottage Gallery 11" className="gallery-image" />
      </div>
      <div className="col-12 col-md-6 imagesBackgroundColour no-padding">
        <img src={gallery12} alt="Shore Cottage Gallery 12" className="gallery-image" />
      </div>
    </div>
    <div className="row">
      <div className="col-12 col-md-6 imagesBackgroundColour no-padding">
        <picture>
          <source srcSet={`${caolIsla_small} 1x,${caolIsla_medium} 2x`} media="(max-width: 600px)" />
          <img srcSet={`${caolIsla_medium} 1x,${caolIsla_large} 2x`}
            src={caolIsla_medium} alt="Seascape with Caol Isla yacht" className="gallery-image"
          />
        </picture>
      </div>
      <div className="col-12 col-md-6 imagesBackgroundColour no-padding">
        <picture>
          <source srcSet={`${corranRoad_small} 1x,${corranRoad_medium} 2x`} media="(max-width: 600px)" />
          <img srcSet={`${corranRoad_medium} 1x,${corranRoad_large} 2x`}
            src={corranRoad_medium} alt="Road To Corran View" className="gallery-image"
          />
        </picture>
      </div>
    </div>
    <div className="row">
      <div className="col-12 col-md-6 imagesBackgroundColour no-padding">
        <picture>
          <source srcSet={`${floatingClouds_small} 1x,${floatingClouds_medium} 2x`} media="(max-width: 600px)" />
          <img srcSet={`${floatingClouds_medium} 1x,${floatingClouds_large} 2x`}
            src={floatingClouds_medium} alt="Seaview with reflection" className="gallery-image"
          />
        </picture>
      </div>
      <div className="col-12 col-md-6 imagesBackgroundColour no-padding">
        <picture>
          <source srcSet={`${rainAndSun_small} 1x,${rainAndSun_medium} 2x`} media="(max-width: 600px)" />
          <img srcSet={`${rainAndSun_medium} 1x,${rainAndSun_large} 2x`}
            src={rainAndSun_medium} alt="Rain and Sun Arnisdale" className="gallery-image"
          />
        </picture>
      </div>
    </div>
    <div className="row">
      <div className="col-12 col-md-4 imagesBackgroundColour no-padding">
        <picture>
          <source srcSet={`${kayakCalmDay_small} 1x,${kayakCalmDay_medium} 2x`} media="(max-width: 600px)" />
          <img srcSet={`${kayakCalmDay_medium} 1x,${kayakCalmDay_large} 2x`}
            src={kayakCalmDay_medium} alt="Kayak view of Shore Cottage" className="gallery-image"
          />
        </picture>
      </div>
      <div className="col-12 col-md-4 imagesBackgroundColour no-padding">
        <picture>
          <source srcSet={`${rockyBeach_small} 1x,${rockyBeach_medium} 2x`} media="(max-width: 600px)" />
          <img srcSet={`${rockyBeach_medium} 1x,${rockyBeach_large} 2x`}
            src={rockyBeach_medium} alt="Rocky Beach Arnisdale" className="gallery-image"
          />
        </picture>
      </div>
      <div className="col-12 col-md-4 imagesBackgroundColour no-padding">
        <picture>
          <source srcSet={`${rockJumping_small} 1x,${rockJumping_medium} 2x`} media="(max-width: 600px)" />
          <img srcSet={`${rockJumping_medium} 1x,${rockJumping_large} 2x`}
            src={rockJumping_medium} alt="Jumping into the sea" className="gallery-image"
          />
        </picture>
      </div>
    </div>
    <div className="row">
      <div className="col-12 col-md-6 imagesBackgroundColour no-padding">
        <picture>
          <source srcSet={`${glenelgView_small} 1x,${glenelgView_medium} 2x`} media="(max-width: 600px)" />
          <img srcSet={`${glenelgView_medium} 1x,${glenelgView_large} 2x`}
            src={glenelgView_medium} alt="Glenelg sunset view" className="gallery-image"
          />
        </picture>
      </div>
      <div className="col-12 col-md-6 imagesBackgroundColour no-padding">
        <picture>
          <source srcSet={`${cottage2_small} 1x,${cottage2_medium} 2x`} media="(max-width: 600px)" />
          <img srcSet={`${cottage2_medium} 1x,${cottage2_large} 2x`}
            src={cottage2_medium} alt="Cottage View 2" className="gallery-image"
          />
        </picture>
      </div>
    </div>
  </div>
);
}

export default Gallery;